import { ItemSetQuestionDetailsProvider } from '@exam-management/question-creation-task-question-management';
import { useParams } from '@exam-management/router';
import { Flex } from '@shared/components';
import { Outlet } from 'react-router-dom';

export default function ItemSetQuestionsLayout() {
  const { taskId, questionId } = useParams(
    '/my-task/question-creation/:taskId/item-set/:questionId',
  );
  return (
    <ItemSetQuestionDetailsProvider taskId={taskId} questionGroupId={questionId}>
      <Flex sx={{ flexDirection: 'column', height: '100%' }}>
        <Outlet />
      </Flex>
    </ItemSetQuestionDetailsProvider>
  );
}
